<template>
<div :style="coverStyle" class="draw-structure-cover">
  <div class="cover-content">
    <div class="cover-head">
      <div>{{step === 'draw-structure' ? 'DRAW STRUCTURE' : 'SUBMIT'}}</div>
      <div class="close-button" @click="triggerVisible"><i class="el-icon-close"></i></div>
    </div>

    <div v-show="step==='draw-structure'" class="draw-structure" id="draw-structure"></div>

    <div v-show="step==='submit'" class="submit-area"><submit ref="submit" :compound="compound"></submit></div>

    <div class="draw-structure-buttons">
      <el-button class="draw-structure-next" type="primary" v-if="step==='draw-structure'" @click="next()">Next</el-button>
      <el-button class="draw-structure-prev" type="primary" v-if="step==='submit'" @click="step='draw-structure'">Prev</el-button>
      <el-button class="draw-structure-submit" type="primary" v-if="step==='submit'" @click="$refs.submit.submit();triggerVisible()">Submit</el-button>
    </div>

  </div>
</div>
</template>

<script>
// import { Kekule } from 'kekule'
import Submit from './Submit.vue'

export default {
  name: 'DrawStructure',

  data () {
    return {
      step: 'draw-structure',
      compound: ''
    }
  },

  computed: {
    coverStyle () {
      return this.value ? {
        left: 0, right: 0, top: 0, bottom: 0
      } : {
        left: '-300%', right: '300%', top: 0, bottom: 0
      }
    }
  },

  components: {
    Submit
  },

  props: [ 'value' ],

  methods: {
    triggerVisible () {
      this.$emit('input', !this.value)
    },

    next () {
      let v = this
      let mol = v.composer.exportObjs(window.Kekule.Molecule)[0]
      v.compound = window.Kekule.IO.saveFormatData(mol, 'smi')
      v.step = 'submit'
    },

    initKekule () {
      let v = this
      v.$store.state.kekulePromise.then(() => {
        v.composer = new window.Kekule.Editor.Composer(document)
        v.composer.setDimension('100%', '500px')
        v.composer.appendToElem(document.getElementById('draw-structure'))
      })
    }
  },

  mounted () {
    let v = this
    this.$nextTick(function () {
      v.initKekule()
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../styles/theme.scss";


.draw-structure-cover {
  position: fixed;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 99;
}

.cover-content {
  width: 1000px;
  margin: 50px auto;
  /*
  background-color: white;
  */
  position: relative;
  background-color: #dadada;
}

.cover-head {
  position: relative;
  font-size: 16px;
  padding: 10px;
  background-color: white;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 10px;
}

.draw-structure-background {
  background-color: #dadada;
  width: 100%;
  padding-top: 10px;
  padding-bottom: 10px;
}

.draw-structure {
  width: 900px;
  margin: 0px auto;
}

.draw-structure-buttons {
  width: 900px;
  margin: 20px auto;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.draw-structure-next {
  margin: 0px 20px 10px auto;
}

.draw-structure-prev {
  margin: 0px auto 10px 20px;
}

.draw-structure-submit {
  margin: 0px 20px 10px auto;
}

.close-button {
  margin-left: auto;
  margin-right: 0;
  /*
  z-index: 99;
  */
  cursor: pointer;
  font-size: 20px;
  opacity: 0.5;
}

.close-button:hover {
  opacity: 1;
}

.submit-area-background {
  background-color: white;
  width: 100%;
}

.submit-area {
  width: 700px;
  margin: 0px auto;
  padding: 10px;
}

.el-button--primary {
  background-color: $theme-color;
  border-color: $theme-color;
}

.el-button--primary:hover {
  opacity: 0.5;
}

</style>

